import { render } from "./SliderSelectView.vue?vue&type=template&id=16365c4b&scoped=true"
import script from "./SliderSelectView.vue?vue&type=script&lang=js"
export * from "./SliderSelectView.vue?vue&type=script&lang=js"

import "./SliderSelectView.vue?vue&type=style&index=0&id=16365c4b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16365c4b"]])

export default __exports__